import { Event, EventFee, Fee } from "../../models"
import { StablingAndExtrasItem, StablingAndExtrasOptionsData } from "../eventStallType/FormatStablingOptionsUtil";
import { formatFeeDateTime } from "../fee/FeeUtils";
import { getEventFeesByEventId } from "./EventFee";

export const getFormattedFeeOptionDataForEventFees = async (event: Event) => {
    let extrasOptionData: StablingAndExtrasOptionsData = {
        label: "Extras",
        options: [{ value: "0", label: "No extra options for this event", cost: "0", description: ""}]
    };

    const currentEventFees: EventFee[] = await getAllEventFeesForEvent(event);
    const optionalEventFees: EventFee[] = currentEventFees.filter(eventFee => !(!!eventFee?.fee?.isPerEntry));
    const formattedData = formatFeeData(optionalEventFees);

    extrasOptionData.options = formattedData;

    return extrasOptionData;
}

const getAllEventFeesForEvent = async (event: Event) => {
    let currentEventFees: EventFee[] = [];
    const queryResult = await getEventFeesByEventId(event.id);
    if (queryResult.isSuccess) {
        currentEventFees = queryResult.result;
    }
    return currentEventFees;
}

export const formatFeeData = (currentEventFees: EventFee[]) => {
    const formattedData: StablingAndExtrasItem[] = [];
    for (let i = 0; i < currentEventFees.length; i++) {
        const current = currentEventFees[i];
        const formatted: StablingAndExtrasItem = formatSingleEventFeeAsStablingAndExtrasItem(current);
        formattedData.push(formatted);
    }
    const sortedData = formattedData.sort((a, b) => a.label.localeCompare(b.label));
    return sortedData;
}

export const formatSingleEventFeeAsStablingAndExtrasItem = (currentEventFee: EventFee, fee?: Fee) => {
    const startDateTime = currentEventFee.fee ? formatFeeDateTime(currentEventFee.fee) : undefined;
    const formatted: StablingAndExtrasItem = {
        value: currentEventFee.id,
        label: currentEventFee.name || "Unknown Name",
        cost: currentEventFee.amount ? currentEventFee.amount.toString() : "Unknown Price",
        description: currentEventFee.description || "",
        startDateTime: startDateTime || undefined,
        isRequired: (!!fee?.isPerEntry) || (!!currentEventFee.fee?.isPerEntry) || false,
        eventFee: currentEventFee,
    };
    return formatted;
}